import { z } from "zod";

export interface Resource {
  ativo: boolean;
  email: string;
  idusuario?: number;
  login: string;
  nome: string;
  senha: string | null;
  cpf: string;
  telefone: string;
  codigo: string
  codigoPermissao: string
  idEndereco?: number;
  nomeMae?: string;
}

const baseSchema = z.object({
  idusuario: z.number().optional(),
  nome: z.string().min(1, "Campo obrigatório"),
  login: z.string()
  .min(1, "Login obrigatório")
  .refine((val) => !val.startsWith('@'), {
    message: "Digite o nome de usuário antes do @",
  }),
  email: z.string()
    .min(1, "E-mail obrigatório")
    .refine((val) => !val.startsWith('@'), {
      message: "Digite o e-mail antes do @",
    }),
  codigo: z.string().nullable().optional(),
  //@ts-ignore
  telefone: z.string(),
  cpf: z.string().nullable().optional(),
  ativo: z.boolean(),
  codigoPermissao: z.string().nullable().optional(),
  idEndereco: z.preprocess(
    (val) => {
      if (val === "" || val === null || val === undefined) return NaN;
      const num = Number(val);
      return isNaN(num) ? NaN : num;
    },
    z.number({
      required_error: "Campo obrigatório",
      invalid_type_error: "Campo obrigatório",
    })
    .min(1, "Campo obrigatório")
    .refine((val) => !isNaN(val), {
      message: "Campo obrigatório",
    })
  ),
  nomeMae: z.string().nullable().optional(),
});

// Schema para criação (senha obrigatória)
export const schema = baseSchema.extend({
  senha: z.string().min(1, "Campo obrigatório").nullable(),
});

// Schema para edição (senha opcional)
export const schemaEdit = baseSchema.extend({
  senha: z.string().nullable().optional(),
});

// Tipo que funciona tanto para criação quanto edição
export type FormValues = z.infer<typeof schemaEdit>;

export function resourceToFormValues({
  ativo,
  ...values
}: Resource): FormValues {
  //@ts-ignore
  return {
    ...values,
    //@ts-ignore
    senha: null,
    ativo: ativo === true,
  };
}

export function formValuesToResource({
  ativo,
  idusuario,
  senha,
  cpf,
  telefone,
  ...values
}: FormValues): Resource {
  //@ts-ignore
  return {
    ...values,
    //@ts-ignore
    cpf: cpf?.replaceAll(/\D/g, ''),
    //@ts-ignore
    senha: senha,
    telefone: telefone?.replaceAll(/\D/g, ''),
    ativo: ativo ? true : false,
  };
}
